module.exports = __webpack_public_path__ + "img/symbol-roman-right.0be8e6aa.png";